<template>
    <div>
        <drop ref="dropper" class="bordercont has-text-centered posRelative" :class="{handCursor: tgt, borderDashed: $parent.$parent.editMode}" @drop="drop" @dragover="dragOver" @dragleave="dragOut" @dragend="dragOut" >
            <button v-show="$parent.$parent.editMode" class="cmsColImgButton button is-small is-coolGreen" @click="fileChooser"><i class="fa fa-image fa-2x"></i></button>
            <div v-show="!img2 && $parent.$parent.editMode && !loaded" class="mas has-text-centered">+</div>
            <textarea  v-show="loaded && $parent.$parent.editMode && type == 'img'" class="tgtTA" placeholder="target" v-model="tgt" @change="changed"></textarea>
            
            <div v-if="type=='img'" >
                 <div class="posRelative">
                     <img  class="imagen" :src="img2" @click="navTo" :class="{handCursor: !$parent.$parent.editMode && tgt}"/>
                     <div v-show="$parent.$parent.editMode || (text != '' && text != '\n') " ref="txt" class="cmsImgTxt" :contenteditable="$parent.$parent.editMode" @focus="setDirty('txt')" @blur="update('txt')"><b>{{text}}</b></div>
                 </div>
            </div>
            <div v-if="type=='profile'" class="prof">
                <img  :src="img2" @click="navTo" :class="{handCursor: !$parent.$parent.editMode && tgt}" class="avatar"/><br/>
                <div class="is-size-3 has-text-white"><b>{{handle}}</b></div>
            </div>
    
            <div v-if="type=='bundle'" class="tn height100"><bundletn   :item="bund"></bundletn></div>
    
            <div v-if="type=='ad'" class="top3">
                <div class="cmsAdContainer miimuEnlarge">
                    <ad class="top25 " style="border-top-right-radius: 5px; "></ad>
                </div>
            </div>
            <input type="file" style="display: none" @change="fileChanged"  ref="fileInput"/>
    
            
    
        </drop>

        <!-- <div>adsfgsdfgsdfgs</div> -->
    </div>
</template>

<script>

import M from 'minimatch'
import bundletn from '../BundleThumbnail.vue'
import ad from '../Ad.vue'
import { AZEventBus } from '../AZEventBus'

export default {
    components: {bundletn, ad},
    props: {
        img: String, index: Number
    },
    data: function() {
        return {
            img2: '',
            tgt: '',
            type: null,
            loaded: false,
            handle: '',
            bund: {},
            text: '',
            dirty: ''
        }
    },

    mounted: function(){

        if(this.$parent.$parent.source[this.$parent.index].params.cols[this.index]){
            this.type = this.$parent.$parent.source[this.$parent.index].params.cols[this.index].type
          
        
            if(this.type == 'img'){
                this.img2 = this.$parent.$parent.source[this.$parent.index].params.cols[this.index].img
                this.tgt = this.$parent.$parent.source[this.$parent.index].params.cols[this.index].tgt
                this.text = this.$parent.$parent.source[this.$parent.index].params.cols[this.index].text
                this.loaded = true;
          
            } else if(this.type == 'profile'){
                this.img2 = this.$parent.$parent.source[this.$parent.index].params.cols[this.index].img
                this.handle = this.$parent.$parent.source[this.$parent.index].params.cols[this.index].handle
                this.tgt = `https://${process.env.VUE_APP_DOMAIN_NAME}/profile/${this.handle}`
                this.loaded = true;

            } else if(this.type == 'bundle'){
                this.bund = this.$parent.$parent.source[this.$parent.index].params.cols[this.index].bund
                this.tgt = `https://${process.env.VUE_APP_DOMAIN_NAME}/profile/${this.handle}/b/${this.bund.mCode}`
                this.loaded = true;
            }  else if(this.type == 'ad'){
                //this.bund = this.$parent.$parent.source[this.$parent.index].params.cols[this.index].bund
                //this.tgt = `http://${process.env.VUE_APP_DOMAIN_NAME}/profile/${this.handle}/b/${this.bund.mCode}`
                this.loaded = true;
            }
        }
            

    },

    methods: {
        dragOver: function(){
            //console.log('asdfadfa')
            if(this.$parent.$parent.dataTransfer.type == 'img')
                this.$refs.dropper.$el.classList.add('imgDragOver')
        },
        dragOut: function(){
            this.$refs.dropper.$el.classList.remove('imgDragOver')
        },
        drop: function(){

            if(!this.$parent.$parent.editMode){
                return
            }


            this.type = this.$parent.$parent.dataTransfer.type

            if(this.type == 'img'){
                this.$parent.$parent.source[this.$parent.index].params.cols[this.index].img = this.$parent.$parent.dataTransfer.img
                this.$parent.$parent.source[this.$parent.index].params.cols[this.index].type = 'img'
                this.$parent.$parent.source[this.$parent.index].params.cols[this.index].text = this.$parent.$parent.dataTransfer.text
                this.text = this.$parent.$parent.dataTransfer.text
                this.img2 = this.$parent.$parent.source[this.$parent.index].params.cols[this.index].img
              
                this.loaded = true;
                if(this.$parent.$parent.dataTransfer.tgt){
                    this.tgt = this.$parent.$parent.dataTransfer.tgt
                    this.$parent.$parent.source[this.$parent.index].params.cols[this.index].tgt = this.tgt
                }
                
                AZEventBus.$emit('pageChanged', null)
            } else if(this.type == 'profile'){
                this.img2 = this.$parent.$parent.dataTransfer.img
                this.handle = this.$parent.$parent.dataTransfer.handle
                this.$parent.$parent.source[this.$parent.index].params.cols[this.index].type = 'profile'
                this.$parent.$parent.source[this.$parent.index].params.cols[this.index].img = this.img2
                this.$parent.$parent.source[this.$parent.index].params.cols[this.index].handle = this.handle
                this.loaded = true;
                
                this.tgt = `https://${process.env.VUE_APP_DOMAIN_NAME}/profile/${this.handle}`
                this.$parent.$parent.source[this.$parent.index].params.cols[this.index].tgt = this.tgt
                AZEventBus.$emit('pageChanged', null)
            } else if(this.type == 'bundle'){
                this.$parent.$parent.source[this.$parent.index].params.cols[this.index].bund = this.$parent.$parent.dataTransfer.bund
                this.bund = this.$parent.$parent.source[this.$parent.index].params.cols[this.index].bund
                this.$parent.$parent.source[this.$parent.index].params.cols[this.index].type = 'bundle'
                this.loaded = true;

                this.tgt = `https://${process.env.VUE_APP_DOMAIN_NAME}/profile/${this.handle}/b/${this.bund.mCode}`
                this.$parent.$parent.source[this.$parent.index].params.cols[this.index].tgt = this.tgt
                AZEventBus.$emit('pageChanged', null)
            } else if(this.type == 'ad'){
                this.$parent.$parent.source[this.$parent.index].params.cols[this.index].bund = {}
                this.bund = {}
                this.$parent.$parent.source[this.$parent.index].params.cols[this.index].type = 'ad'
                this.loaded = true;

                this.tgt = ''
                this.$parent.$parent.source[this.$parent.index].params.cols[this.index].tgt = this.tgt
                AZEventBus.$emit('pageChanged', null)
            }

            this.$refs.dropper.$el.classList.remove('imgDragOver')
            this.$parent.$parent.dataTransfer = {}

        },

        navTo: function(){
            if(!this.$parent.$parent.editMode && this.tgt)
              window.location.href = this.tgt
        },

        changed: function(){
            if(this.tgt){
                this.$parent.$parent.source[this.$parent.index].params.cols[this.index].tgt = this.tgt
                AZEventBus.$emit('pageChanged', null)
            }
        },

        setDirty: function(t){
            this.dirty = this.$refs[t].innerText
        },

        update: function(t){
          if(this.$refs[t].innerText != this.dirty){
            this.$parent.$parent.source[this.$parent.index].params.cols[this.index].text = this.$refs[t].innerText
            AZEventBus.$emit('pageChanged', null)
          }
        },

        fileChooser: function(){
            this.$refs.fileInput.click()
        },

        fileChanged: function(e){
        // getting a hold of the file reference

        var self = this;
        var file = e.target.files[0]; 

        
        // setting up the reader
        var reader = new FileReader();
        reader.readAsDataURL(file); // this is reading as data url

        // here we tell the reader what to do when it's done reading...
        reader.onload = readerEvent => {
            var content = readerEvent.target.result; // this is the content!
            if (/^image\/\w+$/.test(file.type)) {
            reader.readAsDataURL(file);
            reader.onload = function () {

                function w(d){
                    self.$parent.$parent.dataTransfer.type = 'img'
                    self.$parent.$parent.dataTransfer.img = d.img
                    self.$parent.$parent.dataTransfer.text = ''

                    self.drop()

                }

                function n(){


                }


                self.$root.app.apiClient.post('subs/data/cmsimg', {imgFile: content, id: -1}, w, n)

              
                
            };


        } else {
            this.$root.app.showModalOK({message: 'Please select an image file.'});
        }
            
            
        }
    },
    }
}
</script>

<style lang="sass" scoped>
    .mas
        font-size: 80px
        line-height: 80px
        color: #aaa
        position: relative
        top: calc(50% - 40px)

    .cont
        height: 100%
        overflow: hidden
        position: relative
        min-height: 350px

    .tgtTA
        max-width: 110%
        position: absolute
        background-color: black
        color: white
        left: 5px
        top: 5px
        border-left: 6px solid #f1c232
        border-radius: 5px
        z-index: 20

    .avatar
        max-width: 165px
        border-radius: 30px
        border: 5px solid #aaa

    .tn
        vertical-align: top !important
        //border-right: 1px solid #f1c232

    .prof
        //border-left: 1px solid #ccc
        //border-right: 1px solid #ccc
        margin-top: 15px
        border-radius: 30px
        //border-right: 1px solid #ccc

    .bundleThumbnail
        vertical-align: top !important
        margin-right: 0 !important


    .imagen
        min-width: 250px


       
        
</style>